import { GoodsSortType, ItemSort } from 'src/features/filter-goods/type'
import { createEvent, createStore, sample } from 'effector'
import { useEvent, useStore } from 'effector-react'
import { ICatalogGoodBase } from '@entities/goods/contract'
import { $goods } from '@entities/goods/model'
import { onRouteChangeComplete } from '@entities/route/model'
import { sortBy } from 'lodash-es'

export const sortItems: ItemSort[] = [
    { id: 1, content: 'Популярные' },
    { id: 2, content: 'Подешевле' },
    { id: 3, content: 'Подороже' },
    { id: 4, content: 'По алфавиту' }
]

function goodsSort(goods: ICatalogGoodBase[], selectedSort: GoodsSortType) {
    switch (selectedSort) {
        case 1:
            return sortBy(goods, (good: ICatalogGoodBase) => good.sortOrders.sortOrder1)
        case 2:
            return sortBy(goods, (good: ICatalogGoodBase) => good.sortOrders.sortOrder2)
        case 3:
            return sortBy(goods, (good: ICatalogGoodBase) => -good.sortOrders.sortOrder2)
        case 4:
            return sortBy(goods, (good: ICatalogGoodBase) => good.sortOrders.sortOrder3)
        default:
            throw new Error('Ошибка выбора типа сортировки')
    }
}

/**
 * Хранилище текущего
 */
const $selectedSort = createStore<ItemSort>({ id: 1, content: 'Популярные' }).reset(onRouteChangeComplete)

/**
 * Событие на выбор сортировки
 */
const selectSort = createEvent<GoodsSortType>()

/**
 * изменяет выбранную сортировку при вызове события
 */
sample({
    clock: selectSort,
    fn: (sortType) => sortItems.find((x) => x.id === sortType) as ItemSort,
    target: $selectedSort
})

/**
 * При изменеии сортировки, отсортируем гудсы
 */
sample({
    clock: $selectedSort,
    source: $goods,
    fn: (goods, selectedSort) => [...goodsSort(goods, selectedSort.id)],
    target: $goods
})

const useSelectedSort = () => useStore($selectedSort)
const useSelectSort = () => useEvent(selectSort)
export { $selectedSort, useSelectSort, useSelectedSort }
